export default "__VITE_ASSET___YvJM5MT__"